import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button } from "semantic-ui-react";

class LookupVehicle extends Component {
  handleLookupClick = () => {
    const vrm = this._vrm.value;
    this.props.onLookup(vrm);
  };

  render() {
    const { fetching, disabled } = this.props;
    const className = "ui action input fluid" + (disabled ? " disabled" : "");
    return (
      <div className={className}>
        <input id="input-VRM-new" type="text" ref={(input) => (this._vrm = input)} placeholder="e.g. AB19 XYZ" />
        <Button className="new-branding-button" id="lookup-vrm-button-new" color="green" onClick={this.handleLookupClick} loading={fetching} disabled={fetching || disabled ? true : false}>
          Search
        </Button>
      </div>
    );
  }
}

LookupVehicle.propTypes = {
  onLookup: PropTypes.func.isRequired,
  fetching: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default LookupVehicle;
